<template>
	<component :is="wrapComponent" :class="column.class">
		<template v-if="hasActionFn">
			<button
				class="btn btn-link min-w-auto font-small text-decoration-none z-depth-0 text-btn-link m-0 p-0"
				data-toggle="tooltip-city"
				type="button"
				:title="$t(`${actionTitle}`)"
				@click.prevent="onActionFn">
				{{ columnValue }}
			</button>
		</template>
		<template v-else>
			<span v-html="columnValue"></span>
		</template>
	</component>
</template>
<script>
import { resolvePath, isFunction, isString, isNullOrUndefined } from '@config/utils';
export default {
	props: {
		wrapComponent: {
			type: String,
			default: 'td'
		},
		column: {
			type: Object,
			default: () => {
				return {
					field: ''
				}
			}
		},
		row: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	computed: {
		// TODO: copiado do global para não ter que adicionar todo o mixin para apenas essa funcao
		columnValue: function() {
			let val = resolvePath(this.row, this.column.field_label || this.column.field);
			return isFunction(this.valueFn)  ? this.valueFn(val, this.row) : val;
		},
		valueFn: function() {
			return this.column.func;
		},
		actionTitle() {
			return this.column.actionTitle ?? null;
		},
		actionFn() {
			return this.column.actionFn ?? this.column.onClick;
		},
		hasActionFn: function() {
			let fn = isFunction(this.actionFn);
			if(fn) {
				let hasAccess = true;
				let permission = this.column.actionPermission;
				if(!isNullOrUndefined(permission)) {
					hasAccess = isFunction(permission) ? permission(this.row) : (isString(permission) ? this.$auth.check(permission) : !!permission);
				}
				return hasAccess;
			}
			return false;
		},
		// actionTitle: `${idPanel}.list.actions.view-data.title`,
		// 				actionPermission: () => this.allowShow,
	},
	methods: {
		onActionFn: function() {
			if(this.hasActionFn) {
				this.actionFn(this.row);
			}
		}
	}
}
</script>